import React, { useState } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { getCookie } from "../config/webStorage";
import { apiurl } from "../config/config";

const CreateSupplier = () => {
const token = getCookie("token");
  const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    phone: "",
    altPhone: "",
    email: "",
    website: "",
    address: {
      line1: "",
      line2: "",
      city: "",
      state: "",
      country: "India",
      postalCode: "",
    },
    gstin: "",
    pan: "",
    bankDetails: {
      bankName: "",
      branch: "",
      accountNumber: "",
      accountName: "",
      ifsc: "",
    },
    paymentTerms: "",
    creditLimit: "",
    rating: "",
    notes: "",
    status: "active",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e, parent) => {
    const { name, value } = e.target;
    if (parent) {
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [name]: value,
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.post(
        `${apiurl}/api/supplier/create`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (res.data.success) {
        setMessage("Supplier created successfully ✅");
        setFormData({
          name: "",
          contactPerson: "",
          phone: "",
          altPhone: "",
          email: "",
          website: "",
          address: {
            line1: "",
            line2: "",
            city: "",
            state: "",
            country: "India",
            postalCode: "",
          },
          gstin: "",
          pan: "",
          bankDetails: {
            bankName: "",
            branch: "",
            accountNumber: "",
            accountName: "",
            ifsc: "",
          },
          paymentTerms: "",
          creditLimit: "",
          rating: "",
          notes: "",
          status: "active",
        });
      }
    } catch (err) {
      setMessage(err.response?.data?.message || "Error creating Supplier ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
        <Container overflow={"overflow-scroll"}>
    <div className="bg-gray-50 min-h-screen p-6">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <h1 className="text-2xl font-bold mb-6 text-[#4B49AC]">
          Create New Supplier
        </h1>

        {message && (
          <div
            className={`mb-4 px-4 py-2 rounded ${
              message.includes("✅")
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Basic Info */}
          <section>
            <h2 className="font-semibold text-gray-700 mb-3">
              Basic Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="Supplier Name"
                value={formData.name}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="contactPerson"
                placeholder="Contact Person"
                value={formData.contactPerson}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="altPhone"
                placeholder="Alternate Phone"
                value={formData.altPhone}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="website"
                placeholder="Website"
                value={formData.website}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
            </div>
          </section>

          {/* Address */}
          <section>
            <h2 className="font-semibold text-gray-700 mb-3">Address</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="line1"
                placeholder="Address Line 1"
                value={formData.address.line1}
                onChange={(e) => handleChange(e, "address")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="line2"
                placeholder="Address Line 2"
                value={formData.address.line2}
                onChange={(e) => handleChange(e, "address")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.address.city}
                onChange={(e) => handleChange(e, "address")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="state"
                placeholder="State"
                value={formData.address.state}
                onChange={(e) => handleChange(e, "address")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="postalCode"
                placeholder="Postal Code"
                value={formData.address.postalCode}
                onChange={(e) => handleChange(e, "address")}
                className="border rounded px-3 py-2 w-full"
              />
            </div>
          </section>

          {/* Tax & Bank */}
          <section>
            <h2 className="font-semibold text-gray-700 mb-3">
              Tax & Bank Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="gstin"
                placeholder="GSTIN"
                value={formData.gstin}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="pan"
                placeholder="PAN"
                value={formData.pan}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="bankName"
                placeholder="Bank Name"
                value={formData.bankDetails.bankName}
                onChange={(e) => handleChange(e, "bankDetails")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="branch"
                placeholder="Branch"
                value={formData.bankDetails.branch}
                onChange={(e) => handleChange(e, "bankDetails")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="accountNumber"
                placeholder="Account Number"
                value={formData.bankDetails.accountNumber}
                onChange={(e) => handleChange(e, "bankDetails")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="accountName"
                placeholder="Account Name"
                value={formData.bankDetails.accountName}
                onChange={(e) => handleChange(e, "bankDetails")}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="text"
                name="ifsc"
                placeholder="IFSC Code"
                value={formData.bankDetails.ifsc}
                onChange={(e) => handleChange(e, "bankDetails")}
                className="border rounded px-3 py-2 w-full"
              />
            </div>
          </section>

          {/* Other */}
          <section>
            <h2 className="font-semibold text-gray-700 mb-3">
              Additional Info
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="paymentTerms"
                placeholder="Payment Terms"
                value={formData.paymentTerms}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="number"
                name="creditLimit"
                placeholder="Credit Limit"
                value={formData.creditLimit}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              />
              <input
                type="number"
                name="rating"
                placeholder="Rating"
                value={formData.rating}
                onChange={handleChange}
                step="0.1"
                className="border rounded px-3 py-2 w-full"
              />
              <textarea
                name="notes"
                placeholder="Notes"
                value={formData.notes}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
              ></textarea>
            </div>
          </section>

          {/* Submit */}
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-[#4B49AC] text-white px-6 py-2 rounded hover:bg-opacity-90 transition"
            >
              {loading ? "Saving..." : "Create Supplier"}
            </button>
          </div>
        </form>
      </div>
    </div>
            </Container>
    </Layout>
  );
};

export default CreateSupplier;